import { render, staticRenderFns } from "./SpaceForm.vue?vue&type=template&id=c25afedc&"
import script from "./SpaceForm.vue?vue&type=script&lang=js&"
export * from "./SpaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports